<template>
    <div>
        <signature-layout 
            :submitSignature="signPuppyRelease"
            :workflowGuid="registration.workflowGuid"
            :signatureId="signatureId"
            :foundRequest="!!registration"
            :isLoading="isLoading"
            :submittedAt="registration.submissionDate"
        >
            <span slot="title">Approve Kennel Usage in Puppy Release</span>
            <div slot="approvedContent" v-if="registration && registration.mainColor">
                <div class="mt-5">                    
                    <h2>
                        <b>{{ registration.mainColor }}&nbsp;&nbsp;{{ registration.gender }}</b>
                    </h2>
                    <h2>
                        Litter #{{ registration.litterId}}
                    </h2>  
                    <h3 class="mt-5">
                        <b>Ownhership transfer date: </b> <localized-date :date="registration.ownershipTransferDate" />
                    </h3>
                    <h3 class="mt-5">
                        <b>May breed?: </b> {{ registration.isAllowedToBreed ? "Yes" : "No"}}
                    </h3>
                    <h3 class="mt-5">
                        <b>Required kennel name(s) in dog's name:</b>
                    </h3>
                    <ul>
                        <li v-for="kennel in registration.requiredKennels" v-bind:key="kennel.kennelId">
                            {{ kennel.kennelName }}
                        </li>
                    </ul>
                    <div class="mt-5">
                        <h2>New owner info</h2>
                        <span><b>Name: </b> {{registration.newOwner.firstName}} {{ registration.newOwner.lastName }}</span>&nbsp;&nbsp;
                        <span><b>Email: </b> {{registration.newOwner.email}}</span>&nbsp;&nbsp;
                        <span><b>Phone number: </b> {{registration.newOwner.phoneNumber}}</span>
                    </div>
                </div>  
            </div>
            <div slot="legalText">
                <p class="bottom-text">
                    Upon signing, I certify that the registration of this dog requires my kennel's name.
                </p>
            </div>
        </signature-layout>
    </div>    
</template>

<script lang="ts">
import Vue from "vue";
import SignatureLayout from "@/components/common/SignatureLayout.vue";
import puppyReleaseService from '@/services/puppyReleaseService';
import { UserInfo } from "@/types/User";

export default Vue.extend({
  name: 'PuppyReleaseSignature',
  components: {
      SignatureLayout
  },
  data: function() {
      return {
          signatureText: "",
          registration: {} as Object,
          isLoading: false
      };
  },
  props: {
    signatureId: { type: Number },
  },
  methods: {
      signPuppyRelease: function(workflowGuid: String, signatureId: number, text: String) {
          puppyReleaseService.signPuppyRelease(
               signatureId,
               text
           ).then(res => {
             this.$navigate('/');
       }).catch(this.$handleError);
      }
  },
  created() {
      this.isLoading = true;
      puppyReleaseService.getPuppyReleaseDetailsForSignature(this.signatureId).then(res => {
          this.isLoading = false;
          this.registration = res.data;
      });
  },
  watch: {
    signatureId: function (newValue) {
      this.isLoading = true;
      puppyReleaseService.getPuppyReleaseDetailsForSignature(this.signatureId).then(res => {
          this.isLoading = false;
          this.registration = res.data;
      });
    }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  }
});
</script>
